import { Button, PasswordInput, TextInput } from "@mantine/core";
import React, { useEffect, useRef, useState } from "react";
import "./dashboardLogin.css";
import {getAuthServiceState, getChannelDivision, getFlows, getSSORedirectUrl, loginByAuthService, loginByAuthServiceSSO, sendOtp} from "../../services/salescodeAuthService";
import {
  getAccessToken,
  getContactAddressType,
  getLob,
  getLOBClientConfig,
  getLoginPolicyandTwoFactorAuthState,
  getLoginUIConfig,
  getMobileKeyName,
  getUserDetailsFromContext,
  login,
  logoutUser,
  sendForgotPasswordOtpAddress,
  setAuthContext,
  validateContactAddress,
} from "../../services/authenticationService";
import { useLocation, useNavigate } from "react-router-dom";
import LoginUiComponent from "../../components/loginUiComponent/loginUiComponent";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { fetchSaleLensConfig, getMetaDataConfig, getNewConfiguration, getSalesLensUrl } from "../../services/uiConfigService";
import ReverseTimer from "../../components/ReverseTimer/ReverseTimer";
import { blockLoginState } from "../../types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Switch from "react-switch";
import { Checkbox } from "@mui/material";
import { loginPolicyState } from "../../types";
import { ChannelkartNetworkGet } from "../../services/networkService";
import { EnvironmentRegistry } from "../../services/registry/environmentRegistry";
import { eventEnum, logEvent } from "../../services/eventsService/eventService";
import TwoFactorAuth from "../twoFactorAuth/TwoFactorAuth";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { Loader } from "../../components/loader/Loader";
import store from "../../stateManagement/store";
import { getOnboardingConfig, isProductionMovementCompleted, isStandardLob } from "../../services/userOnboardService/userOnboardService";
import { FlowConfiguration,FlowResponse,LoginResponse } from "@salescode/salescode-auth-web-sdk";

export default function DashboardLogin() {
  const CUR_COMPONENT = "LogInAndChangePassword"
  const { translate } = usePortalTranslation();
  const userNameInput = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const [toggleState, setToggleState] = useState<boolean>(false);
  const [policiesState, setPoliciesState] = useState<loginPolicyState>({
    showPolicy: false,
    tncLink: "",
    privacyLink: "",
  });
  const [policyCheckbox, setPolicyCheckbox] = useState<boolean>(true);
  const [ssoLoginURL, setSsoLoginURL] = useState<string>("");
  const [redirectURL,setredirectURL]=useState<string>("");
  const [authRedirectURL,setAuthRedirectURL]=useState<string>("");
  const [clientName,setClientName]=useState<string>('');
  const serverURL = EnvironmentRegistry.getServerUrl();

  const location = useLocation();
  const [isTwoFactorEnabled , setIsTwoFactorEnabled] = useState<boolean>(false);
  const contactAddressType = useRef<string>('');


  const userCredsInfo = useRef({});
  const senderIdRef = useRef<string | undefined>(undefined);
  const [currentStep , setCurentStep] = useState(0);
  const [loading , setLoading] = useState<boolean>(true);
  const [isSSOEnabled , setIsSSOEnabled] = useState<boolean>(false);
  const [showPasswordFields , setShowPasswordFields] = useState<boolean>(true);
  const [loader , setLoader] = useState<boolean>(true);
  const [loginUIConfig , setLoginUIConfig] = useState<any>();
  const [isEndToEnd, setIsEndToEnd] = useState<boolean>(false); 

  const [isAuthServiceEnabled,setIsAuthServiceEnabled]=useState<boolean>();
  const [userName, setUserName] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [loginContext, setLoginContext] = useState<string>('');
  const [isAuthServiceSsoEnabled, setIsAuthServiceSsoEnabled]= useState<boolean| undefined>(undefined);
  const [flowConfiguration, setFlowConfiguration] = useState<any>(null);

  const twoFactorContactType = useRef<string | null>(null);
  const queryParams = new URLSearchParams(location.search);
  const isSsoCallback = queryParams.has("sessionId"); 
  const [sessionId, setSessionId] = useState<string | null>(null);

  async function getAndSetPolicyandTwoFactorAuthConfig() {
    try{
      
      const {contactAddressType:type , contactType} = await getContactAddressType();
      
      const { policiesObj, isTwoFactorActive , isSSOEnabled:ssoEnabled , showPortalLoginFields} = await getLoginPolicyandTwoFactorAuthState();
      setIsSSOEnabled(ssoEnabled);
      contactAddressType.current = type;
      twoFactorContactType.current = contactType;
      setPoliciesState(policiesObj);
      setShowPasswordFields(showPortalLoginFields);
      setIsTwoFactorEnabled(isTwoFactorActive);
      return {ssoEnabled};
    }catch(error){
      console.error(error);
      return {ssoEnabled:false};
    }
  }


  async function getAndSetSSODetails(){
    try {
      const response = await ChannelkartNetworkGet("/v1/sso/configuration", undefined);
      setClientName(response.data.features[0].applicationLogin.clientName);
      setSsoLoginURL(response.data.features[0].applicationLogin.loginUrl)
    } catch (error) {
      console.error(error);
    }
  }

  async function init(){
    
    if(sessionStorage.getItem("accessDenied")){
      openPopup("Alert","Session Expired: Your session has expired due to inactivity or security reasons. Please log in again to continue accessing the application.");
      sessionStorage.removeItem("accessDenied");
    }
    setLoading(true);
    
    const {ssoEnabled}  = await getAndSetPolicyandTwoFactorAuthConfig();

    if(ssoEnabled){
      await getAndSetSSODetails()
    }
    
    setLoading(false);
    // getAndSetPolicyandTwoFactorAuthConfig();
    // getAndSetSSODetails();
  }


useEffect(() => {
  const params = new URLSearchParams(location.search);
  if (params.has("sessionId")) {
    setSessionId(params.get("sessionId"));
  }
}, []);


useEffect(() => {
  const checkAuthService = async () => {
    const response = await getAuthServiceState(); 
    setIsAuthServiceEnabled(response.isAuthService);
  };
  checkAuthService();
}, []);

useEffect(() => {
  if (sessionId) {
    const handleSsoCallback = async () => {
      try {
        const map = { sessionId };
        const response = await loginByAuthServiceSSO(map);
     if(response && response.data){
        console.log(response, "SSO Callback Response");
        await handleLogin(response);}
        else{
          openPopup("Error", "Entered credentials are either incorrect or not Registered, please validate credentials");
          setTimeout(() => {
            window.location.href = "/dashboardLogin";
          }, 2000);
        }
      } catch (error) {
        console.error("Error handling SSO callback", error);
      }
    };
    handleSsoCallback();
  }
}, [sessionId]);



useEffect(() => {
  if (!isSsoCallback && isAuthServiceEnabled) {
    const getFlowResponse = async () => {
      const flowResponse: FlowResponse = await getFlows(); 
      if (flowResponse.flowConfiguration.content.length==0)
      {
        setFlowConfiguration(null);
      }else{
      setFlowConfiguration(flowResponse.flowConfiguration);
}
      if (flowResponse.ssoConfigurations && flowResponse.ssoConfigurations.content.length > 0) {
        setIsAuthServiceSsoEnabled(true); 
        const res = await getSSORedirectUrl(
          flowResponse.ssoConfigurations.content[0].registrationId, 
          flowResponse.ssoConfigurations.content[0].provider
        ); 
        setAuthRedirectURL(res.content[0]);
      } else {
        setIsAuthServiceSsoEnabled(false); 
      }
    };
    getFlowResponse();
  }
}, [isAuthServiceEnabled, isSsoCallback]);

  useEffect(() => {
    const fetchLoginPolicy = async () => {
      try {
        setLoader(true);
        const { loginUIConfig } = await getLoginUIConfig();
        setLoginUIConfig(loginUIConfig);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        console.error('Error fetching login policy:', error);
      }
    };
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    if (mediaQuery.matches) {
      setLoader(true);
      fetchLoginPolicy();
    }else{
      setLoader(true);
      setLoginUIConfig(null);
      setLoader(false);
    }
    const handleResize = async() => {
      if (mediaQuery.matches) {
        setLoader(true);
        await fetchLoginPolicy();
      }else{
        setLoader(true);
        setLoginUIConfig(null);
        setLoader(false);
      }
    };
    mediaQuery.addEventListener('change', handleResize);
    return () => {
      mediaQuery.removeEventListener('change', handleResize);
    };
  }, []);

  useEffect(()=>{
    const ssoLoginURLParts = ssoLoginURL.split('/');
    const url = ssoLoginURLParts.slice(0, 6).join('/');
    let finalURl=`${serverURL}${url}/${clientName}?page=${window.location.origin}/dashboard`;
    setredirectURL(finalURl);
  },[ssoLoginURL])

  useEffect(() => {
    
    init();
  }, []);
  
  const [blockLoginState, setBlockLoginState] = useState<blockLoginState>({
    attemptsLeft: 1e9,
    timeLeft: 0,
    showError: false,
  });
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const lobInput = useRef<HTMLInputElement>(null);
  const passwordInput = useRef<HTMLInputElement>(null);

  const displayDashboard = async ()=>{
    const salesLensUrl = await getSalesLensUrl()
    console.log("salesLensUrl",salesLensUrl)
    if(salesLensUrl){
      window.location.href = salesLensUrl;
    }else{
      await logoutUser();
    }
  }

  const handleLogin = async (authSsoResponse ?:any) => {
    const userName: string = userNameInput.current?.value! || authSsoResponse?.data.user.loginId;
    const password: string = passwordInput.current?.value! || " ";
    const lob: string = getLob()
    setUserName(userName);
    setPassword(password);

    
    if (policiesState.showPolicy && !policyCheckbox) {
      openPopup(
        "Error",
        "Please accept the T&C and Privacy Policy before proceeding"
      );
    } else if (!lob) {
      openPopup("Error", "LOB field cannot be blank");
    } else if (!userName) {
      openPopup("Error", "Username field cannot be blank");
    } else if (!password) {
      openPopup("Error", "Password field cannot be blank");
    } else if (userName && password && lob) {
      try {
        let loginResponse;
        if (authSsoResponse) {
          loginResponse = authSsoResponse;
        } else if (isAuthServiceEnabled && !isTwoFactorEnabled) {
          const flows = await getFlows();
          loginResponse = await loginByAuthService(userName, password, lob, flows.isEndToEnd ?? false, (flows?.flowConfiguration.content[0] ?? {}) as FlowConfiguration);
        } else if (isAuthServiceEnabled && isTwoFactorEnabled) {
          const flows = await getFlows();
          setIsEndToEnd(flows.isEndToEnd);
          if (flows.flowConfiguration.content[0].providerName === "form") {
            let formResponse = await loginByAuthService(userName, password, lob, flows.isEndToEnd ?? false, (flows?.flowConfiguration.content[0] ?? {}) as FlowConfiguration);
            let response = await sendOtp(userName, password, lob, flows.isEndToEnd ?? false, "send-otp", formResponse.loginContext);
            if ('loginContext' in response) {
              setLoginContext(response.loginContext as string);
            }
            setCurentStep(1);
            return;
          }
        } else {
          loginResponse = await login(userName, password, lob);
        }
        const keyName = contactAddressType.current === "sms" ? getMobileKeyName(loginResponse?.data?.user ?? {}):'email';

        const contactAddress = twoFactorContactType.current === "loginid" ? userName : loginResponse?.data?.user?.[keyName] ?? null;      
        if(loginResponse){
        if (loginResponse.status === 200 ) {
          let isChannelDivision = await getChannelDivision(loginResponse?.data?.user?.designation, loginResponse?.data?.token);
          sessionStorage.setItem("runPrepareCatalogue", 'true');
          if(isTwoFactorEnabled){
            const addressType = twoFactorContactType.current ?? contactAddressType.current;
            const {isValid , message} = validateContactAddress(addressType , contactAddress);
            if(!isValid){
              setToggleState(false);
              openPopup("Error",message);
              return;
          
            }
            userCredsInfo.current = {
              lob,
              user: loginResponse?.data?.user,
              contactAddressType: contactAddressType.current,
              contactAddress: loginResponse?.data?.user?.[keyName],
              token: loginResponse?.data?.token 
            }

            const response = await sendForgotPasswordOtpAddress(
              contactAddress,
              contactAddressType.current,
              twoFactorContactType.current
            );

            if(response?.response?.statusCode !== 200 && response?.response?.statusCode !== 201 && response?.response?.statusCode !== 202){
              throw Error("Error While Sending OTP");
            }

            senderIdRef.current = response?.response?.id;

            setCurentStep(1);
          }else{
              loginResponse.data.user["channelDivision"] = isChannelDivision;
              setAuthContext(loginResponse.data.user, loginResponse.data.token);
              localStorage.setItem("lob",lob);
              logEvent(eventEnum.login,{feature_name:"login"})
              const onlySaleslens = await fetchSaleLensConfig();
              if(onlySaleslens){
                return await displayDashboard()
              }else{
                const portalConfig = await getMetaDataConfig(
                  "clientConfig",
                  "portal_configuration"
                );

                if (portalConfig && isStandardLob(portalConfig) && !(isProductionMovementCompleted(portalConfig))) {
                  const onboardingConfig = await getOnboardingConfig();

                  if (!onboardingConfig || !onboardingConfig.isOnboarding) {
                    return navigate("/dashboard");
                  }
                  
                  return navigate("/onboarding");
                } 

                return navigate("/dashboard");
              }
          }
        
        } else {
          throw new Error(loginResponse);
        }}
      } catch (error: any) {
        const networkService = store.getState().serviceRegistry.get("ChannelkartNetwork");
        const token = await networkService.authState.getHttpEncryptionKey();
        setToggleState(false);
        const { errorCode, message } = error?.response?.data ?? {message : error.message};
        let popupMessage = "Entered credentials are incorrect, please enter correct credentials";
        if (errorCode) {
          switch (errorCode) {
            case "EU014": {
              const digit = message.match(/\d+/);
              // Check if a match is found
              if (digit) {
                // Extracted number of attempts
                const numberOfAttempts = parseInt(digit[0]);
                setBlockLoginState({
                  timeLeft: 0,
                  attemptsLeft: numberOfAttempts,
                  showError: true,
                });
              } else {
              }
              break;
            }
            case "EU015": {
              const digit = message.match(/\d+/);
              if (digit) {
                // Extracted number of attempts
                const secondsLeft = parseInt(digit[0]);
                setBlockLoginState({
                  attemptsLeft: 0,
                  timeLeft: secondsLeft,
                  showError: true,
                });
                const hours = Math.floor(secondsLeft / 3600);
                const minutes = Math.floor((secondsLeft % 3600) / 60);
                const remainingSeconds = secondsLeft % 60;
                popupMessage = `Login is blocked for next ${hours} hours, ${minutes} minutes ${remainingSeconds} seconds`;
              } else {
              }
              break;
            }
            case "EU016": {
              popupMessage =
                "Your account has been disabled, please contact your system administrator";
              break;
            }
          }
          openPopup("Error", popupMessage);
          setToggleState(false);
          return;
        }
        openPopup("Error", popupMessage);
      }
    } else {
      
      openPopup("Error", "Entered credentials are incorrect, please enter correct credentials");
    }
    setToggleState(false);
  };

  const openForgetPasswordPage = () => {
    return navigate("forgotPassword");
  };

  const onTimerEnd = () => {
    setBlockLoginState({ ...blockLoginState, showError: false, timeLeft: 0 });
  };

  function renderPasswordRightElement() {
    if (blockLoginState.showError) {
      if (blockLoginState.timeLeft > 0) {
        return (
          <ReverseTimer
            className="dashboard-login-password-right-content dashboard-login-timer"
            initialTime={blockLoginState.timeLeft}
            onTimerZero={onTimerEnd}
          />
        );
      } else if (blockLoginState.attemptsLeft !== 1e9) {
        return (
          <div className="dashboard-login-password-right-content dashboard-login-attempt-message">
            Attempts Remaining: {blockLoginState.attemptsLeft}
          </div>
        );
      }
    }
    return !showPassword ? (
      <FontAwesomeIcon
        onClick={() => setShowPassword(true)}
        icon={faEyeSlash}
      />
    ) : (
      <FontAwesomeIcon onClick={() => setShowPassword(false)} icon={faEye} />
    );
  }

  const loginDisabled =
    blockLoginState.showError && blockLoginState.timeLeft > 0;
  return (
<>
{
      loader ? <Loader /> :
      <LoginUiComponent loginUIConfig={loginUIConfig}>
      {
        loading ? <Loader /> :
          <>
            {
              currentStep === 0 &&
              <form className="loginInputs">

              { 
                showPasswordFields && (!isAuthServiceEnabled || (isAuthServiceEnabled && (flowConfiguration!=null && flowConfiguration.content[0].providerName==='form'))) && (
                  <>
                      <TextInput
                        sx={{ width: "70%", marginTop: "5%", borderRadius: "7rem" }}
                        autoComplete="off"
                        id="usernameInput"
                        name="usernameInput"
                        placeholder={translate(TranslationEnum.login_and_change_password,"User Name")}
                        ref={userNameInput}
                        onChange={() =>
                          setBlockLoginState({ ...blockLoginState, showError: false })
                        }
                      />
                      <TextInput
                        disabled={loginDisabled}
                        autoComplete="off"
                        type={showPassword ? "text" : "password"}
                        sx={{ width: "70%", marginTop: "5%" }}
                        id="passwordInput"
                        readOnly
                        placeholder={translate(TranslationEnum.login_and_change_password,"Password")}
                        ref={passwordInput}
                        rightSection={renderPasswordRightElement()}
                        onFocus={(e) => {
                          e.target.removeAttribute("readOnly")
                          setBlockLoginState({ ...blockLoginState, showError: false });
                        }}
                      />
                      {!loginDisabled && (
                        <div style={loginUIConfig ? { color: "#ED1229" } : {}} className="forgotPassword" onClick={openForgetPasswordPage}>
                         {translate(TranslationEnum.login_and_change_password,"Forgot Password")}?
                        </div>
                      )}
                      {policiesState.showPolicy && (
                        <div className="dashboard-login-policy">
                          <Checkbox
                            className="login-policy-checkbox"
                            size="small"
                            onChange={() => setPolicyCheckbox(!policyCheckbox)}
                            checked={policyCheckbox}
                          />
                          <span>
                            {translate(TranslationEnum.login_and_change_password,"I have read")}{" "}
                            <a
                              className="login-policy-link"
                              href={policiesState.tncLink}
                              target="_blank"
                            >
                              {translate(TranslationEnum.login_and_change_password,"T&Cs")}
                            </a>{" "}
                             {translate(TranslationEnum.login_and_change_password,"and")}{" "}
                            <a
                              className="login-policy-link"
                              href={policiesState.privacyLink}
                              target="_blank"
                            >
                              {translate(TranslationEnum.login_and_change_password,"Privacy Policy")}
                            </a>
                          </span>{" "}
                        </div>
                      )}
                      <Switch
                        className="dashboard-login-toggle"
                        disabled={toggleState}
                        onChange={() => {
                          setToggleState(!toggleState);
                          handleLogin();
                        }}
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            setToggleState(!toggleState);
                            handleLogin();
                          }
                        }}
                        checked={toggleState}
                        offColor={loginUIConfig ? "#ED1229" : "FFFFFF"}
                        onColor={loginUIConfig ? "#ED1229" : "#00C6B1"}
                        onHandleColor="#FFFFFF"
                        offHandleColor={loginUIConfig ? "FFFFFF" : "#B5B5B5"}
                        draggable={true}
                        translate={"yes"}
                        handleDiameter={27}
                        uncheckedIcon={
                          <>
                            <div style={loginUIConfig ? { color:"white" } : {}}  className="login-toggle-unchecked-icon-status">{translate(TranslationEnum.login_and_change_password,"VERIFY")}</div>
                          </>
                        }
                        checkedIcon={
                          <>
                            <div className="login-toggle-checked-icon-status">{translate(TranslationEnum.login_and_change_password,"VERIFYING")}</div>
                          </>
                        }
                        boxShadow="-5px 3px 20px #00000026"
                        height={34}
                        width={102}
                      />
                    </>
                )}
               
                  {
                  isSSOEnabled && !isAuthServiceEnabled && !isAuthServiceSsoEnabled && <Button style={{ backgroundColor: loginUIConfig ? "#FF0000" :"transparent", marginTop: loginUIConfig ? "10px" : "0px" }} onClick={() => {
                    window.open(redirectURL, "_self");
                  }}>{translate(TranslationEnum.login_and_change_password,"Continue with SSO")}</Button> 
                }
                
                {isAuthServiceSsoEnabled === true && (
                  <Button
                    style={{
                      backgroundColor: "transparent",  
                      marginTop: "20px",
                      width: "70%",
                      height: "40px",
                      border: "2px solid #FFFFFF",  
                      borderRadius: "8px",
                      color: "#FFFFFF",  
                      padding: "8px 16px",
                      cursor: "pointer",
                      transition: "all 0.3s ease"
                    }}
                    onClick={() => {
                      window.open(authRedirectURL, "_self");
                    }}
                  >
                    {translate(TranslationEnum.login_and_change_password, "Continue with SSO")}
                  </Button>
                )}
              
              </form>
            }

            {
              currentStep === 1 && <TwoFactorAuth userCredsInfo={userCredsInfo.current} twoFactorContactType={twoFactorContactType.current} senderId={senderIdRef.current} isEndToEnd={isEndToEnd} userName={userName} password={password} loginContext={loginContext}/>
            }
          </>

      }

      </LoginUiComponent>
    }
</>
  );
}
